var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalileo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 80,
    height: 80,
    rx: 8,
    fill: "#27292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.76 36.0031C102.698 35.999 102.636 36.0057 102.575 36.0171L102.331 36.063C102.27 36.0743 102.211 36.0912 102.154 36.1134L88.3438 41.4667C88.1219 41.5527 87.8766 41.5568 87.652 41.4782L72.3241 36.1135C72.1141 36.0399 71.8855 36.0386 71.6745 36.1096L56.96 41.0667C56.4 41.2533 56 41.7333 56 42.3467V82.6667C56 83.3821 56.5385 83.9506 57.2404 83.9969C57.3021 84.001 57.3639 83.9943 57.4247 83.9829L57.6691 83.937C57.7296 83.9257 57.7889 83.9088 57.8462 83.8866L71.6562 78.5333C71.8781 78.4473 72.1234 78.4432 72.348 78.5218L87.6759 83.8866C87.8859 83.9601 88.1145 83.9614 88.3255 83.8904L103.04 78.9333C103.6 78.7467 104 78.2667 104 77.6533V37.3333C104 36.6179 103.461 36.0494 102.76 36.0031ZM74.6667 43.9961C74.6667 43.3073 75.3468 42.8247 75.997 43.0523L84.6637 46.0856C85.0648 46.226 85.3333 46.6045 85.3333 47.0295V76.0039C85.3333 76.6927 84.6532 77.1753 84.003 76.9477L75.3363 73.9144C74.9352 73.774 74.6667 73.3955 74.6667 72.9705V43.9961ZM61.3333 45.9452C61.3333 45.5158 61.6074 45.1344 62.0143 44.9974L68.0143 42.9774C68.6623 42.7592 69.3333 43.2413 69.3333 43.9252V73.0478C69.3333 73.461 69.0793 73.8316 68.694 73.9805L62.694 76.3005C62.0387 76.5539 61.3333 76.0704 61.3333 75.3678V45.9452ZM98.6667 74.0549C98.6667 74.4842 98.3926 74.8656 97.9857 75.0026L91.9857 77.0226C91.3377 77.2408 90.6667 76.7587 90.6667 76.0748V46.9788C90.6667 46.5657 90.9207 46.1951 91.306 46.0461L97.306 43.7261C97.9613 43.4727 98.6667 43.9563 98.6667 44.6588V74.0549Z",
    fill: "#A6B7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2775 0 0 0 0 0.225 0 0 0 0 0.6 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalileo);
export default __webpack_public_path__ + "static/media/Galileo.a076e4bc67978475100793a060499df3.svg";
export { ForwardRef as ReactComponent };